import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProductCard } from "../printing/ProductCard";
import colorSharp2 from "../../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import { digitalLinks } from "./digitalLinks";
import { graphixLinks } from "./graphixLinks";
import { offsetLinks } from "./offsetLinks";

export const Capacity = () => {

  
  return (
    <section className="productPrinting" id="capacity">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Capacity</h2>
                <p>“At TotleSoft, we offers a guaranteed convenience. We have a team of professional graphic designers, machine operators, lithographers, and finishers waiting to surprise you ...and trust our production strength to come through at the same time we promissed to deliver the job” <span className="chris">Take a glance at some of our state-of-the-art machines and graphix strength below:</span></p>
                <p className='onlyMobile'>Tap the Offset, Digital or Design Samples button to learn more</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Offset</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Digital</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Design Samples</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          offsetLinks.map((offsetLink, index) => {
                            return (
                              <ProductCard
                                key={index}
                                {...offsetLink}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>

                    <Tab.Pane eventKey="second">
                    <Row>
                        {
                          digitalLinks.map((digitalLink, index) => {
                            return (
                              <ProductCard
                                key={index}
                                {...digitalLink}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>

                    <Tab.Pane eventKey="third">
                    <Row>
                        {
                          graphixLinks.map((graphixLink, index) => {
                            return (
                              <ProductCard
                                key={index}
                                {...graphixLink}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} alt=''></img>
    </section>
  )
}
